var BASE_URL = process.env.API_BASE_URL
export default {
  BASE_URL: BASE_URL,
  CUSTOMER_PAYMENT_DASHBOARD_URL: BASE_URL + 'customer/account/v1/contractor/payments?local=',
  CUSTOMER_PAYMENT_DASHBOARD: 'CUSTOMER_PAYMENT_DASHBOARD'
}